/* ============================================
   SR BOOTS — Theme JavaScript (Improved)
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ─────────────────────────────
  // Utils (safe body lock system)
  // ─────────────────────────────
  let bodyLocked = false;

  function lockBody() {
    document.body.style.overflow = 'hidden';
    bodyLocked = true;
  }

  function unlockBody() {
    document.body.style.overflow = '';
    bodyLocked = false;
  }

  function safeUnlock() {
    if (bodyLocked) unlockBody();
  }

  // ─────────────────────────────
  // Sticky Header
  // ─────────────────────────────
  const header = document.querySelector('.site-header');

  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    });
  }

  // ─────────────────────────────
  // Hero Slider
  // ─────────────────────────────
  document.querySelectorAll('.hero-slider').forEach(slider => {
    const slides = slider.querySelectorAll('.hero-slide');
    const dots = slider.querySelectorAll('.hero-dot');

    if (!slides.length) return;

    let current = 0;
    let autoInterval;

    function goTo(n) {
      slides[current]?.classList.remove('active');
      dots[current]?.classList.remove('active');

      current = (n + slides.length) % slides.length;

      slides[current]?.classList.add('active');
      dots[current]?.classList.add('active');
    }

    function startAuto() {
      autoInterval = setInterval(() => goTo(current + 1), 5000);
    }

    function stopAuto() {
      clearInterval(autoInterval);
    }

    slider.querySelector('.hero-prev')?.addEventListener('click', () => {
      stopAuto();
      goTo(current - 1);
      startAuto();
    });

    slider.querySelector('.hero-next')?.addEventListener('click', () => {
      stopAuto();
      goTo(current + 1);
      startAuto();
    });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        stopAuto();
        goTo(i);
        startAuto();
      });
    });

    if (slides.length > 1) startAuto();
  });

  // ─────────────────────────────
  // Mobile Menu
  // ─────────────────────────────
  const menuBtn = document.querySelector('.js-menu-open');
  const menuClose = document.querySelector('.js-menu-close');
  const menuOverlay = document.querySelector('.mobile-menu-overlay');
  const mobileMenu = document.querySelector('.mobile-menu');

  function openMenu() {
    menuOverlay?.classList.add('active');
    mobileMenu?.classList.add('active');
    lockBody();
  }

  function closeMenu() {
    menuOverlay?.classList.remove('active');
    mobileMenu?.classList.remove('active');
    safeUnlock();
  }

  menuBtn?.addEventListener('click', openMenu);
  menuClose?.addEventListener('click', closeMenu);
  menuOverlay?.addEventListener('click', closeMenu);

  // ─────────────────────────────
  // Search Overlay
  // ─────────────────────────────
  const searchBtns = document.querySelectorAll('.js-search-open');
  const searchClose = document.querySelector('.js-search-close');
  const searchOverlay = document.querySelector('.search-overlay');

  function openSearch() {
    searchOverlay?.classList.add('active');
    searchOverlay?.querySelector('input')?.focus();
    lockBody();
  }

  function closeSearch() {
    searchOverlay?.classList.remove('active');
    safeUnlock();
  }

  searchBtns.forEach(btn => btn.addEventListener('click', openSearch));
  searchClose?.addEventListener('click', closeSearch);

  searchOverlay?.addEventListener('click', e => {
    if (e.target === searchOverlay) closeSearch();
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeMenu();
      closeSearch();
    }
  });

  // ─────────────────────────────
  // Pack Tabs
  // ─────────────────────────────
  document.querySelectorAll('.packs-section').forEach(section => {
    const tabs = section.querySelectorAll('.pack-tab');
    const panels = section.querySelectorAll('.pack-panel');

    if (!tabs.length || !panels.length) return;

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        panels.forEach(p => (p.style.display = 'none'));

        tab.classList.add('active');
        if (panels[i]) panels[i].style.display = 'grid';
      });
    });

    // init first tab
    panels.forEach((p, i) => {
      p.style.display = i === 0 ? 'grid' : 'none';
    });

    tabs[0]?.classList.add('active');
  });

  // ─────────────────────────────
  // Fade-in on scroll
  // ─────────────────────────────
  const fadeEls = document.querySelectorAll('.fade-in');

  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    fadeEls.forEach(el => obs.observe(el));
  } else {
    fadeEls.forEach(el => el.classList.add('visible'));
  }

  // ─────────────────────────────
  // Add to Cart (Shopify AJAX)
  // ─────────────────────────────
  document.querySelectorAll('.js-add-to-cart').forEach(btn => {
    btn.addEventListener('click', async function () {
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      const originalText = btn.textContent;

      btn.textContent = '...';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (!res.ok) throw new Error('Cart error');

        btn.textContent = '✓ Añadido';
        await updateCartCount();

        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);

      } catch (err) {
        btn.textContent = originalText;
        btn.disabled = false;
      }
    });
  });

  // ─────────────────────────────
  // Cart count update
  // ─────────────────────────────
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });

    } catch (e) {}
  }

  updateCartCount();

});
/* ============================================
   AÑADIDO — Página de producto, carrito, FAB contacto
   ============================================ */
document.addEventListener('DOMContentLoaded', function () {

  // ─────────────────────────────
  // Galería de producto (miniaturas)
  // ─────────────────────────────
  document.querySelectorAll('.product-gallery-thumbs img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.querySelector('.product-gallery-main img');
      if (mainImg) mainImg.src = thumb.getAttribute('data-full') || thumb.src;
      document.querySelectorAll('.product-gallery-thumbs img').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // ─────────────────────────────
  // Selector de variantes (talla / color)
  // ─────────────────────────────
  document.querySelectorAll('.option-swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      if (swatch.classList.contains('is-disabled')) return;
      var group = swatch.closest('.product-option-values');
      if (group) group.querySelectorAll('.option-swatch').forEach(function (s) { s.classList.remove('is-active'); });
      swatch.classList.add('is-active');
      if (typeof window.updateSelectedVariant === 'function') window.updateSelectedVariant();
    });
  });

  // ─────────────────────────────
  // Selector de cantidad
  // ─────────────────────────────
  document.querySelectorAll('.qty-selector').forEach(function (selector) {
    var input = selector.querySelector('input');
    var minus = selector.querySelector('.js-qty-minus');
    var plus = selector.querySelector('.js-qty-plus');
    if (minus) minus.addEventListener('click', function () {
      var val = parseInt(input.value, 10) || 1;
      if (val > 1) input.value = val - 1;
    });
    if (plus) plus.addEventListener('click', function () {
      var val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
    });
  });

  // ─────────────────────────────
  // Acordeón (envíos, talla, etc.)
  // ─────────────────────────────
  document.querySelectorAll('.acc-head').forEach(function (head) {
    head.addEventListener('click', function () {
      head.parentElement.classList.toggle('is-open');
    });
  });

  // ─────────────────────────────
  // Añadir al carrito desde la página de producto
  // ─────────────────────────────
  var mainAddBtn = document.querySelector('.js-add-to-cart-main');
  if (mainAddBtn) {
    mainAddBtn.addEventListener('click', async function () {
      if (mainAddBtn.disabled) return;
      var variantId = mainAddBtn.getAttribute('data-variant-id');
      var qtyInput = document.querySelector('.qty-selector input');
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var feedback = document.querySelector('.js-add-feedback');
      if (!variantId) return;

      var originalText = mainAddBtn.textContent;
      mainAddBtn.textContent = 'Añadiendo...';
      mainAddBtn.disabled = true;

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        });
        if (!res.ok) throw new Error('Cart error');

        mainAddBtn.textContent = '✓ Añadido';
        if (feedback) {
          feedback.innerHTML = '✓ Producto añadido al carrito. <a href="/cart">Ver carrito →</a>';
          feedback.classList.add('success');
        }

        var cartRes = await fetch('/cart.js');
        var cart = await cartRes.json();
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });

        setTimeout(function () {
          mainAddBtn.textContent = originalText;
          mainAddBtn.disabled = false;
        }, 1800);

      } catch (err) {
        mainAddBtn.textContent = originalText;
        mainAddBtn.disabled = false;
        if (feedback) feedback.textContent = 'No se ha podido añadir. Inténtalo de nuevo.';
      }
    });
  }

  // ─────────────────────────────
  // Carrito — actualizar cantidad / eliminar línea
  // ─────────────────────────────
  document.querySelectorAll('.js-cart-qty-update').forEach(function (input) {
    input.addEventListener('change', function () {
      var key = input.getAttribute('data-key');
      var qty = parseInt(input.value, 10) || 0;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { window.location.reload(); });
    });
  });

  document.querySelectorAll('.js-cart-remove').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var key = link.getAttribute('data-key');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  // ─────────────────────────────
  // Botón flotante de contacto
  // ─────────────────────────────
  var fabWrap = document.querySelector('.js-contact-fab-wrap');
  var fabToggle = document.querySelector('.js-contact-fab-toggle');
  if (fabWrap && fabToggle) {
    fabToggle.addEventListener('click', function () {
      fabWrap.classList.toggle('is-open');
    });
    document.addEventListener('click', function (e) {
      if (fabWrap.classList.contains('is-open') && !fabWrap.contains(e.target)) {
        fabWrap.classList.remove('is-open');
      }
    });
  }

});
